if (!customElements.get('ugc-section')) {
  class UGCSection extends HTMLElement {
    connectedCallback() {
      for (const closeElement of this.querySelectorAll('.js-modal-close')) {
        closeElement.addEventListener('click', this.closeModal.bind(this));
      }

      for (const element of this.thumbsSlider.querySelectorAll('.js-slider-item')) {
        element.addEventListener('click', this.onThumbsClick.bind(this));
        element.addEventListener('keyup', (event) => {
          if (event.code === 'Enter') this.onThumbsClick(event);
        });
      }

      for (const carousel of this.querySelectorAll('row-carousel')) {
        carousel.addEventListener('CarouselChanged', this.onCarouselChanged.bind(this));
      }

      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.closeModal()
      })
    }

    disconnectedCallback() {
    }

    onCarouselChanged(e) {
      const movingIndex = e.detail?.currentIndex || 0
      for (const carousel of this.querySelectorAll('row-carousel')) {
        if (carousel !== e.currentTarget) carousel.moveToIndex(movingIndex, false);
        if (carousel.classList.contains('js-ugc-content-slider')) {
          this.updateModalContent();
        }
      }
    }

    updateModalContent() {
      const contentIndex = this.contentSlider.currentIndex
      const contentElement = this.contentSlider.querySelector(`.js-slider-item[data-index="${contentIndex}"]`)
      if (!contentElement) return

      for (const title of this.modalTitles) {
        title.innerHTML = contentElement.getAttribute('data-title');
      }

      for (const link of this.modalLinks) {
        link.setAttribute('href', contentElement.getAttribute('data-url'));
      }
    }

    onThumbsClick(event) {
      event.preventDefault()
      const clickedItem = event.currentTarget
      const movingIndex = clickedItem.getAttribute('data-index')
      for (const carousel of this.querySelectorAll('row-carousel:not(.js-ugc-thumbs-slider)')) {
        carousel.moveToIndex(movingIndex, false, false);
      }
      this.openModal()
    }

    openModal() {
      this.modal.classList.add('active')
      this.updateModalContent()
    }

    closeModal() {
      this.modal.classList.remove('active')
    }

    get modal() {
      return this.querySelector('.js-ugc-modal')
    }

    get thumbsSlider() {
      return this.querySelector('.js-ugc-thumbs-slider')
    }

    get contentSlider() {
      return this.querySelector('.js-ugc-content-slider')
    }

    get modalTitles() {
      return this.querySelectorAll('.js-ugc-modal-title')
    }

    get modalLinks() {
      return this.querySelectorAll('.js-ugc-modal-link')
    }
  }

  customElements.define('ugc-section', UGCSection)
}
